module.exports = __webpack_public_path__ + "static/media/arrow-colapse.81fe9bcd.svg";